(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* money */
  const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  const fmt = (cents) => {
    const n = Number(cents) / 100;
    const [i, d] = n.toFixed(2).split('.');
    const map = {
      amount: `${group(i, ',')}.${d}`,
      amount_no_decimals: group(String(Math.round(n)), ','),
      amount_with_comma_separator: `${group(i, '.')},${d}`,
      amount_no_decimals_with_comma_separator: group(String(Math.round(n)), '.'),
      amount_with_apostrophe_separator: `${group(i, "'")}.${d}`
    };
    return (window.SX.money || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => map[k] || map.amount);
  };

  /* panels */
  let lastFocus = null;
  const open = (el) => {
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const f = el.querySelector('button, a, input');
    if (f) setTimeout(() => f.focus(), 50);
  };
  const close = (el) => {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };
  const drawer = () => $('#CartDrawer');
  const menu = () => $('#SxMenu');

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-cart-open]') && drawer()) { e.preventDefault(); open(drawer()); }
    if (t.closest('[data-drawer-close]')) close(drawer());
    if (t.closest('[data-menu-open]')) { open(menu()); $('[data-menu-open]').setAttribute('aria-expanded', 'true'); }
    if (t.closest('[data-menu-close]')) { close(menu()); $('[data-menu-open]').setAttribute('aria-expanded', 'false'); }
    const ch = t.closest('[data-change]');
    if (ch) { e.preventDefault(); changeLine(ch.dataset.change, Number(ch.dataset.qty)); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .mnav.is-open').forEach(close);
  });

  /* cart */
  const refresh = async (openAfter) => {
    const url = `${window.SX.root.replace(/\/$/, '')}/?sections=sx-cart-drawer`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    const json = await res.json();
    const doc = new DOMParser().parseFromString(json['sx-cart-drawer'], 'text/html');
    const fresh = $('#CartDrawerBody', doc);
    if (fresh) $('#CartDrawerBody').innerHTML = fresh.innerHTML;
    const meta = $('#CartDrawerBody [data-cart-meta]');
    const count = meta ? Number(meta.dataset.count) : 0;
    $$('[data-cart-count]').forEach((c) => { c.textContent = count; c.hidden = count === 0; });
    if (openAfter && !drawer().classList.contains('is-open')) open(drawer());
  };

  const add = async (items) => {
    const res = await fetch(`${window.SX.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
    return data;
  };

  const changeLine = async (key, quantity) => {
    const body = $('#CartDrawerBody');
    body.style.opacity = '.5';
    try {
      await fetch(`${window.SX.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      await refresh(false);
    } finally { body.style.opacity = ''; }
  };

  const busy = (btn, on) => { if (!btn) return; btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); };

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    const quick = form.matches('[data-quick-add]');
    const pdp = form.matches('[data-product-form]');
    if (!quick && !pdp) return;
    e.preventDefault();
    const btn = e.submitter || form.querySelector('[type="submit"]');
    const err = form.querySelector('[data-error]');
    if (err) err.hidden = true;
    const fd = new FormData(form);
    const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
    if (pdp) $$('[data-addon]:checked', form).forEach((a) => items.push({ id: Number(a.value), quantity: 1 }));
    busy(btn, true);
    try {
      await add(items);
      await refresh(true);
      if (pdp) $$('[data-addon]:checked', form).forEach((a) => { a.checked = false; });
      if (pdp) updateTotal(form);
    } catch (x) {
      if (err) { err.textContent = x.message; err.hidden = false; } else { alert(x.message); }
    } finally { busy(btn, false); }
  });

  /* product page pricing */
  const pdpRoot = $('[data-pdp]');
  const updateTotal = (form) => {
    if (!pdpRoot || !form) return;
    const live = pdpRoot.dataset.live === 'true';
    const disc = { 1: 0, 2: live ? Number(pdpRoot.dataset.d2) : 0, 3: live ? Number(pdpRoot.dataset.d3) : 0 };
    const sel = form.querySelector('[data-variant]');
    const unit = Number(sel ? sel.selectedOptions[0].dataset.price : form.querySelector('[name="id"]').dataset.price);
    $$('[data-tier]', form).forEach((el) => {
      const t = Number(el.dataset.tier);
      el.textContent = fmt(Math.round(unit * t * (100 - disc[t]) / 100));
    });
    const qty = Number((form.querySelector('[name="quantity"]:checked') || {}).value || 1);
    let total = Math.round(unit * qty * (100 - disc[qty]) / 100);
    $$('[data-addon]:checked', form).forEach((a) => { total += Number(a.dataset.price); });
    const out = form.querySelector('[data-total]');
    if (out) out.textContent = fmt(total);
    if (sel) {
      const btn = form.querySelector('[data-atc]');
      const disabled = sel.selectedOptions[0].disabled;
      if (btn) btn.disabled = disabled;
      const url = new URL(location.href);
      url.searchParams.set('variant', sel.value);
      history.replaceState(null, '', url);
    }
  };

  if (pdpRoot) {
    const form = $('[data-product-form]', pdpRoot);
    form.addEventListener('change', () => updateTotal(form));
    updateTotal(form);

    const sticky = $('[data-sticky]');
    const atc = $('[data-atc]', form);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        const b = sticky.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      }).observe(atc);
    }
  }
})();
